import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_einvoice_discrepancies_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  gen_doc_hdr_guids: fromDatatype.TextDatatypeInterface;
  to_irb_hdr_guids: fromDatatype.TextDatatypeInterface;
  section_code: fromDatatype.VarcharDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  txn_amount: fromDatatype.NumericDatatypeInterface;
  doc_count: fromDatatype.IntegerDatatypeClass;
  description: fromDatatype.TextDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_einvoice_discrepancies_report_line_RowClass
  implements bl_fi_einvoice_discrepancies_report_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_hdr_guids: fromDatatype.TextDatatypeInterface;
    to_irb_hdr_guids: fromDatatype.TextDatatypeInterface;
    section_code: fromDatatype.VarcharDatatypeInterface;
    sort_code: fromDatatype.VarcharDatatypeInterface;
    txn_amount: fromDatatype.NumericDatatypeInterface;
    doc_count: fromDatatype.IntegerDatatypeClass;
    description: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
